export * from './storage.helper';
export * from "./history";
export * from "./isLoggedIn";
export * from "./baseURL";
export const logout = () => {
    window.location.href = "/";
    // localStorage.removeItem("token");
}


export const HOURS_FROM = localStorage.getItem('hours_from');

export const HOURS_TO = localStorage.getItem('hours_to');
export const CHANNEL = localStorage.getItem('channel');
